/* Doro clearance landing page (sections/doro-clr-*.liquid) */
(function () {
  if (window.DoroClearance) return;

  function formatMoney(cents) {
    var amount = cents / 100;
    var hasCents = cents % 100 !== 0;
    return '$' + amount.toLocaleString('en-AU', {
      useGrouping: false,
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function refreshCartCounts() {
    var counters = document.querySelectorAll('[data-dclr-cart-count]');
    if (!counters.length) return;
    fetch((window.theme && theme.routes && theme.routes.cart ? theme.routes.cart : '/cart') + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        counters.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  /*
   * Magnifying-glass lens over the chair photo, matching the live clearance collection page:
   * the mouse (or a touch drag) inspects any point, and detail tabs move the lens to preset points.
   */
  function Magnifier(card) {
    this.card = card;
    this.media = card.querySelector('[data-dclr-media]');
    this.img = this.media.querySelector('[data-dclr-img]');
    this.lens = this.media.querySelector('[data-dclr-lens]');
    this.lensWindow = this.lens.firstElementChild;
    this.lensImg = this.lens.querySelector('img');
    this.caption = this.media.querySelector('[data-dclr-caption]');
    this.tabs = Array.prototype.slice.call(card.querySelectorAll('[data-dclr-tab]'));
    this.inspectScale = parseFloat(this.media.dataset.inspectScale) || 2.3;
    this.inspectCaption = this.media.dataset.inspectCaption || '';
    this.pinned = null;
    this.state = null;
    this.touchId = null;
    this.bind();
  }

  Magnifier.prototype.canHover = function (evt) {
    return evt.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches;
  };

  // The photo is object-fit: contain, so work out where the picture actually sits inside the media box.
  Magnifier.prototype.contentRect = function () {
    var img = this.img;
    if (!img.complete || !img.naturalWidth) return null;
    var scale = Math.min(img.offsetWidth / img.naturalWidth, img.offsetHeight / img.naturalHeight);
    var width = img.naturalWidth * scale;
    var height = img.naturalHeight * scale;
    return {
      left: img.offsetLeft + (img.offsetWidth - width) / 2,
      top: img.offsetTop + (img.offsetHeight - height) / 2,
      width: width,
      height: height
    };
  };

  Magnifier.prototype.pointFromEvent = function (evt) {
    var rect = this.contentRect();
    if (!rect) return null;
    var box = this.media.getBoundingClientRect();
    var x = (evt.clientX - box.left - rect.left) / rect.width;
    var y = (evt.clientY - box.top - rect.top) / rect.height;
    return x >= 0 && x <= 1 && y >= 0 && y <= 1 ? { x: x, y: y } : null;
  };

  Magnifier.prototype.show = function (state) {
    var rect = this.contentRect();
    if (!rect) {
      this.state = state;
      return;
    }
    var radius = this.lens.offsetWidth / 2;
    var px = rect.left + state.x * rect.width;
    var py = rect.top + state.y * rect.height - (state.touch ? 54 : 0);
    var zoomWidth = rect.width * state.scale;
    var zoomHeight = rect.height * state.scale;

    this.lens.style.left = clamp(px, radius + 10, this.media.clientWidth - radius - 10) - radius + 'px';
    this.lens.style.top = clamp(py, radius + 8, this.media.clientHeight - radius - 14) - radius + 'px';
    this.lensImg.style.width = zoomWidth + 'px';
    this.lensImg.style.height = zoomHeight + 'px';
    this.lensImg.style.transform = 'translate3d(' +
      (this.lensWindow.clientWidth / 2 - state.x * zoomWidth) + 'px,' +
      (this.lensWindow.clientHeight / 2 - state.y * zoomHeight) + 'px,0)';
    this.caption.textContent = state.caption;
    this.media.classList.add('is-magnified');
    this.state = state;
  };

  Magnifier.prototype.hide = function () {
    this.state = null;
    this.media.classList.remove('is-magnified');
    this.caption.textContent = '';
  };

  Magnifier.prototype.setActiveTab = function (active) {
    this.tabs.forEach(function (tab) {
      var on = tab === active;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-pressed', on);
    });
  };

  Magnifier.prototype.showTab = function (tab) {
    if (!tab || !tab.dataset.scale) {
      this.setActiveTab(this.tabs[0]);
      this.hide();
      return;
    }
    this.setActiveTab(tab);
    this.show({
      x: parseFloat(tab.dataset.x),
      y: parseFloat(tab.dataset.y),
      scale: parseFloat(tab.dataset.scale),
      caption: tab.dataset.caption || ''
    });
  };

  Magnifier.prototype.inspect = function (point, touch) {
    this.setActiveTab(null);
    this.show({ x: point.x, y: point.y, scale: this.inspectScale, caption: this.inspectCaption, touch: touch });
  };

  Magnifier.prototype.reset = function () {
    this.pinned = null;
    this.showTab(null);
  };

  Magnifier.prototype.setImage = function (src, alt) {
    if (!src) return;
    this.img.removeAttribute('srcset');
    this.img.src = src;
    this.img.alt = alt || '';
    this.lensImg.src = src;
  };

  Magnifier.prototype.bind = function () {
    var self = this;
    var media = this.media;

    media.addEventListener('pointermove', function (evt) {
      if (self.touchId === evt.pointerId) {
        var touchPoint = self.pointFromEvent(evt);
        if (touchPoint) self.inspect(touchPoint, true);
        else self.reset();
        return;
      }
      if (!self.canHover(evt)) return;
      var point = self.pointFromEvent(evt);
      if (point) self.inspect(point, false);
      else self.reset();
    });

    media.addEventListener('pointerleave', function (evt) {
      if (evt.pointerType === 'mouse') self.reset();
    });

    media.addEventListener('pointerdown', function (evt) {
      if (evt.pointerType === 'mouse' || !evt.isPrimary) return;
      var point = self.pointFromEvent(evt);
      if (!point) return;
      evt.preventDefault();
      self.touchId = evt.pointerId;
      media.setPointerCapture(evt.pointerId);
      self.inspect(point, true);
    });

    var endTouch = function (evt) {
      if (self.touchId !== evt.pointerId) return;
      self.touchId = null;
      if (media.hasPointerCapture(evt.pointerId)) media.releasePointerCapture(evt.pointerId);
      self.reset();
    };
    media.addEventListener('pointerup', endTouch);
    media.addEventListener('pointercancel', endTouch);
    media.addEventListener('lostpointercapture', endTouch);

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('pointerenter', function (evt) {
        if (self.canHover(evt)) self.showTab(tab);
      });
      tab.addEventListener('pointerleave', function (evt) {
        if (self.canHover(evt)) self.showTab(self.pinned);
      });
      tab.addEventListener('focus', function () { self.showTab(tab); });
      tab.addEventListener('blur', function () { self.showTab(self.pinned); });
      tab.addEventListener('click', function () {
        self.pinned = tab.dataset.scale ? tab : null;
        self.showTab(self.pinned);
      });
      tab.addEventListener('keydown', function (evt) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(evt.key) === -1) return;
        evt.preventDefault();
        var count = self.tabs.length;
        var next = evt.key === 'Home' ? 0
          : evt.key === 'End' ? count - 1
          : (index + (evt.key === 'ArrowRight' ? 1 : -1) + count) % count;
        self.tabs[next].focus();
      });
    });

    this.card.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') self.reset();
    });

    var refresh = function () {
      if (self.state) self.show(self.state);
    };
    this.img.addEventListener('load', refresh);
    window.addEventListener('resize', refresh);
  };

  function ProductCard(el) {
    this.el = el;
    this.variants = JSON.parse(el.querySelector('[data-dclr-variants]').textContent);
    this.discount = parseInt(el.dataset.codeDiscount, 10) || 0;
    this.atc = el.querySelector('[data-dclr-atc]');
    this.error = el.querySelector('[data-dclr-error]');
    this.swapImages = el.dataset.swapImages === 'true';
    this.variant = this.variants.find(function (v) {
      return String(v.id) === el.dataset.selectedVariant;
    }) || this.variants[0];
    this.options = this.variant ? this.variant.options.slice() : [];

    el.addEventListener('click', this.onClick.bind(this));
    this.render();
  }

  ProductCard.prototype.findVariant = function (options) {
    return this.variants.find(function (v) {
      return v.options.every(function (value, i) { return value === options[i]; });
    });
  };

  ProductCard.prototype.onClick = function (evt) {
    var optionBtn = evt.target.closest('[data-dclr-option]');
    if (optionBtn) {
      this.options[parseInt(optionBtn.dataset.dclrOption, 10)] = optionBtn.dataset.value;
      var next = this.findVariant(this.options);
      if (next) {
        this.variant = next;
        if (this.swapImages && next.featured_image && this.el.dclrMagnifier) {
          this.el.dclrMagnifier.setImage(next.featured_image.src, next.featured_image.alt);
        }
      }
      this.render();
      return;
    }

    if (evt.target.closest('[data-dclr-atc]')) {
      this.addToCart();
    }
  };

  ProductCard.prototype.render = function () {
    var self = this;
    var variant = this.variant;

    this.el.querySelectorAll('[data-dclr-option]').forEach(function (btn) {
      var index = parseInt(btn.dataset.dclrOption, 10);
      var selected = self.options[index] === btn.dataset.value;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected);

      var candidate = self.options.slice();
      candidate[index] = btn.dataset.value;
      var match = self.findVariant(candidate);
      btn.classList.toggle('is-unavailable', !match || !match.available);

      var delta = btn.querySelector('[data-dclr-delta]');
      if (delta) {
        var base = self.options.slice();
        base[index] = btn.dataset.firstValue;
        var baseVariant = self.findVariant(base);
        var diff = match && baseVariant ? match.price - baseVariant.price : 0;
        delta.textContent = diff > 0 ? ' +' + formatMoney(diff) : '';
      }
    });

    this.el.querySelectorAll('[data-dclr-swatch-name]').forEach(function (label) {
      label.textContent = self.options[parseInt(label.dataset.dclrSwatchName, 10)];
    });

    if (!variant) {
      this.atc.disabled = true;
      this.atc.textContent = this.atc.dataset.unavailableLabel;
      return;
    }

    var price = this.el.querySelector('[data-dclr-price]');
    var compare = this.el.querySelector('[data-dclr-compare]');
    var codePrice = this.el.querySelector('[data-dclr-code-price]');
    if (price) price.textContent = formatMoney(variant.price);
    if (compare) {
      var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
      compare.hidden = !showCompare;
    }
    if (codePrice) codePrice.textContent = formatMoney(Math.max(variant.price - this.discount, 0));

    this.atc.disabled = !variant.available;
    this.atc.textContent = variant.available ? this.atc.dataset.label : this.atc.dataset.soldOutLabel;
  };

  ProductCard.prototype.addToCart = function () {
    var self = this;
    if (!this.variant || this.atc.disabled) return;

    this.atc.disabled = true;
    this.atc.setAttribute('aria-busy', 'true');
    if (this.error) this.error.hidden = true;

    fetch(window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: this.variant.id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add to cart');
          return data;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: self.variant.id }
        }));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

        var after = window.theme && theme.settings ? theme.settings.afterAddToCart : 'drawer';
        if (after === 'page' || !document.querySelector('.js-cart-drawer')) {
          window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
        } else if (after === 'drawer') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            detail: { opener: self.atc }
          }));
        }
      })
      .catch(function (error) {
        if (self.error) {
          self.error.textContent = error.message;
          self.error.hidden = false;
        }
      })
      .finally(function () {
        self.atc.removeAttribute('aria-busy');
        self.render();
      });
  };

  // Fallback for browsers/iframes (e.g. the theme editor) where the async Clipboard API is blocked.
  function legacyCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-1000px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, text.length);
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(field);
    return ok;
  }

  // Copy synchronously first (still inside the click gesture), then try the Clipboard API.
  // The API promise can stay pending (e.g. a permission prompt in an iframe), so it is capped.
  function copyText(text) {
    if (legacyCopy(text)) return Promise.resolve(true);
    if (!navigator.clipboard || !navigator.clipboard.writeText) return Promise.resolve(false);
    return Promise.race([
      navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return false; }
      ),
      new Promise(function (resolve) { setTimeout(function () { resolve(false); }, 1000); })
    ]);
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-dclr-copy]').forEach(function (btn) {
      if (btn.dataset.dclrBound) return;
      btn.dataset.dclrBound = 'true';
      btn.addEventListener('click', function () {
        var hint = btn.parentElement.querySelector('[data-dclr-copy-hint]');
        copyText(btn.dataset.dclrCopy).then(function (ok) {
          if (!ok) {
            // Copy is blocked: select the code so the customer can copy it manually.
            var range = document.createRange();
            range.selectNodeContents(btn.querySelector('[data-dclr-copy-text]') || btn);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
          btn.classList.toggle('is-copied', ok);
          if (hint) hint.textContent = ok ? hint.dataset.copiedLabel : hint.dataset.failedLabel;
          clearTimeout(btn._dclrTimer);
          btn._dclrTimer = setTimeout(function () {
            btn.classList.remove('is-copied');
            if (hint) hint.textContent = hint.dataset.defaultLabel;
          }, 2500);
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.dclr-card').forEach(function (el) {
      if (el.dclrMagnifier || !el.querySelector('[data-dclr-lens]')) return;
      el.dclrMagnifier = new Magnifier(el);
    });
    root.querySelectorAll('[data-dclr-card]').forEach(function (el) {
      if (el.dclrCard) return;
      el.dclrCard = new ProductCard(el);
    });
    initCopyButtons(root);
  }

  window.DoroClearance = { init: init };
  document.addEventListener('on:cart:change', refreshCartCounts);
  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
